import { memo } from "react";
import { View, Banner } from "@src/components";
import { MonitoringUpsellBanner } from "./MonitoringUpsellBanner";
import { MonitoringUpgradeDialog } from "./MonitoringUpgradeDialog";
import { MonitoringRequestSentDialog } from "./MonitoringRequestSentDialog";

interface MonitoringBannerSectionProps {
  showMonitoring: boolean;
  onUpgrade: () => void;
}

export const MonitoringBannerSection = memo<MonitoringBannerSectionProps>(({ showMonitoring, onUpgrade }) =>
  showMonitoring ?
    <Banner
      variant="info"
      title={`Monitoring has been enabled for all cameras on site.\nSite-wide recording is also on.`}
    />
  : <MonitoringUpsellBanner onUpgrade={onUpgrade} />,
);

export const SiteWideRecordingFooter = memo(() => (
  <View mt="3xl">
    <Banner variant="info" title="Site-wide recording is always on." />
  </View>
));

interface MonitoringDialogsProps {
  showUpgradeModal: boolean;
  setShowUpgradeModal: (v: boolean) => void;
  showRequestSentModal: boolean;
  setShowRequestSentModal: (v: boolean) => void;
  handleUpgradeRequest: () => void;
}

export const MonitoringDialogs = memo<MonitoringDialogsProps>(
  ({ showUpgradeModal, setShowUpgradeModal, showRequestSentModal, setShowRequestSentModal, handleUpgradeRequest }) => (
    <>
      <MonitoringUpgradeDialog
        visible={showUpgradeModal}
        onClose={() => setShowUpgradeModal(false)}
        onSendRequest={handleUpgradeRequest}
      />
      <MonitoringRequestSentDialog visible={showRequestSentModal} onClose={() => setShowRequestSentModal(false)} />
    </>
  ),
);
